<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M2.5,782.5v7h2l-4,5l-4-5h2v-7H2.5L2.5,782.5z M4.86,792.25l5.64,2.25v4l-10,4l-10-4v-4l5.64-2.25l1.21,1.51L-7,795.5l7.5,3
	l7.5-3l-4.35-1.74L4.86,792.25z"/>
</svg>

</template>